"use client";

// Global error boundary — catches unhandled exceptions in any route that
// doesn't have its own error.tsx. Must be a Client Component (Next.js requirement).

import { useEffect } from "react";

import { ERROR_ACTIONS_CLASS, ErrorRetryButton } from "@/components/shared/error-retry-button";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[ErrorBoundary]", error);
  }, [error]);

  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <h1 className="font-display text-[clamp(28px,3vw,36px)] font-light leading-tight text-foreground">
        Algo deu errado
      </h1>
      <p className="mt-4 max-w-md text-[15px] leading-relaxed text-fg-muted">
        Ocorreu um erro inesperado. Tente novamente ou volte para a página inicial.
      </p>
      <div className={ERROR_ACTIONS_CLASS}>
        <ErrorRetryButton reset={reset} />
        <Button asChild>
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
          <a href="/">Página inicial</a>
        </Button>
      </div>
    </main>
  );
}
